// Shared IBAN shape test for account-learning guards. Anything that fails here is
// parser `Othr/Id` fallback garbage and must never be learned into
// `company_bank_accounts`.
//
// Defined as "does the canonicalizer accept it", so this can never drift from the
// matchers' own acceptance the way a hand-copied normalizer would — it IS the same
// code path (`toValidSwiftIban` = leading-slash strip + `toValidIban`).

import { toValidSwiftIban } from '../../../utils/iban.ts';

export function isIbanShaped(raw: string | null | undefined): boolean {
  return toValidSwiftIban(raw) !== null;
}
